<template>
  <div class="content-container">
    <search-comp @onSearch="attachData" @onReset="onReset">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-2">
              <div class="das-form-input">
                <div class="label">Date Range</div>
                <div class="child-w-80">
                  <el-select
                    v-model="searchParams.dateType"
                    :disabled="disabledDate"
                  >
                    <el-option
                      v-for="(hotel, index) in dateRangeType"
                      :key="index"
                      :value="hotel.id"
                      :label="hotel.name"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </div>

            <div class="das-form-col col-4">
              <div class="das-form-input">
                <div class="label">Từ ngày</div>
                <div class="child-w-80">
                  <!-- :date-data="agentItem.representative_card_date" -->
                  <!-- v-model="agentItem.representative_card_date" -->
                  <!-- @changeCalendar="onChangeDate2" -->
                  <CalendarRange
                    v-model="datetimeRange"
                    style="display: block"
                    :disabled="disabledDate"
                    mode="date"
                    @input="setDateRange"
                  />
                </div>
              </div>
            </div>
            <div class="das-form-col col-2">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Nguồn OTA' }}
                </div>
                <div class="child-w-80">
                  <el-select
                    v-model="searchParams.sourceId"
                    filterable
                    clearable
                  >
                    <el-option
                      v-for="item in sourceOptions"
                      :key="item.id"
                      :label="`(${item.code}) ${item.name}`"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div class="das-form-col col-2">
              <div class="das-form-input">
                <div class="label">Booking ID (CM)</div>
                <div class="child-w-80">
                  <!-- v-model="searchParams.roomNumber" -->
                  <input v-model="searchParams.bookingId" type="text" />
                </div>
              </div>
            </div>
            <div class="das-form-col col-2">
              <div class="das-form-input">
                <div class="label">Tên khách</div>
                <div class="child-w-80">
                  <input
                    v-model="searchParams.name"
                    type="text"
                    :disabled="disabledDate"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="das-form-row"></div>
        </div>
      </div>
    </search-comp>

    <div class="content-box">
      <div class="section-box outline">
        <div class="das-form-container">
          <div class="das-form-title-container justify-space-between">
            <div class="das-form-title">
              <span class="main-title">Báo cáo đặt phòng OTA</span>
            </div>
            <div class="button-containers-title">
              <InfoBtn @click="dialogFormVisible = true" />
              <el-dropdown trigger="click" @command="handleCommand">
                <button class="btn medium primary outline download-button">
                  <i class="el-icon-download"></i>
                </button>
                <el-dropdown-menu>
                  <!-- <el-dropdown-item command="pdf">Xuất PDF</el-dropdown-item> -->
                  <el-dropdown-item command="excel"
                    >Xuất Excel</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
              <!-- <button class="btn primary small">Xuất Excel</button> -->
            </div>
            <!-- <button class="btn medium primary outline">Thêm</button> -->
          </div>
          <hr />

          <div class="w-full">
            <el-table
              class="report-table overflow-auto"
              :height="'600px'"
              :data="rows"
              :border="true"
            >
              <el-table-column
                v-for="(item, index) in columns"
                :key="index"
                :prop="item.field"
                :label="item.headerName"
                :min-width="item?.minWidth || 50"
                :max-width="item?.maxWidth || item?.minWidth || null"
                :header-align="'center'"
                :align="
                  item.cellClass === 'ag-cell-right'
                    ? 'right'
                    : 'ag-cell-center'
                "
              >
                <template v-slot="scope">
                  {{
                    item.headerName == '#'
                      ? scope.$index + 1
                      : item.headerName == $t('grid.column.pmsCode')
                        ? null
                        : getCellValue(scope.row, item)
                  }}
                  <a
                    v-if="item.headerName == $t('grid.column.pmsCode')"
                    class="cursor-pointer"
                    style="color: blue; text-decoration: underline"
                    @click="onViewBooking(scope.row.pms_recode)"
                  >
                    {{ scope.row.pms_recode }}
                  </a>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <!-- <div v-loading="loading" class="grid-scroll mt-10">
            <GridVx
              ref="agGrid"
              :columns="columns"
              :rows="rows"
              dom-layout="scroll"
              class="agGrid"
              :header-height-setter="headerHeightSetter"
              row-selection="false"
              :suppress-cell-focus="true"
              :is-header-height-setter="true"
              :default-col-def="defaultColDef"
              :auto-select-first-row="false"
              :suppress-row-transform="true"
              :auto-size-cell="true"
            />
          </div> -->
          <div class="das-form-container">
            <div class="das-form-group">
              <div class="das-form-row">
                <h4 class="das-form-col col-4" style="text-align: -webkit-left">
                  Tổng: {{ $displayCurrency(this.totalAmount) }} VNĐ
                </h4>

                <h4
                  class="das-form-col col-4"
                  style="text-align: -webkit-center"
                >
                  Tổng số khách: {{ this.totalTraveller }}
                </h4>
                <h4
                  class="das-form-col col-4"
                  style="text-align: -webkit-right"
                >
                  Tổng số phòng: {{ this.totalRoom }}
                </h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      title="Chú thích"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <ul class="annotate-container">
            <li>#: Đánh số thứ tự kết quả tìm kiếm: tăng dần, bắt đầu từ 1</li>
            <li>
              PMS Recode: Recode lớn nhất của PMS, khi click vào recode sẽ
              redirect sang màn hình xem chi tiết recode
            </li>
            <li>CM Recode: recode nhận được từ Hotellink</li>
            <li>
              Status: trạng thái của booking, trạng thái lấy theo các trạng thái
              trên PMS: Đã đặt, Đang ở, Đã hủy, Không đến, Đã trả
            </li>
            <li>Channel: nguồn booking</li>
            <li>
              Booking Date: Ngày booking được đặt, format hiển thị: HH:MM
              DD/MM/YYYY
            </li>
            <li>Checkin: ngày CI của booking. Format hiển thị: DD/MM/YYYY</li>
            <li>Checkout: ngày CO của booking. Format hiển thị: DD/MM/YYYY</li>
            <li>Tên khách: Tên khách booking</li>
            <li>Số điện thoại: số điện thoại của booking</li>
            <li>SL phòng: số lượng phòng trong booking</li>
            <li>SL khách: số lượng khách trong booking</li>
            <li>Total Amount: tổng tiền trong booking</li>
            <li>Payment note: Lấy từ API getbooking của hotellink</li>
          </ul>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button class="btn primary small" @click="dialogFormVisible = false">
            {{ $t('button.cancel') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import CalendarRange from '@/components/CalendarSelect/CalendarRange.vue'
import InfoBtn from './components/InfoBtn.vue'
import {
  getListHotelinkReport,
  getListHotelinkReportExcel
} from '@/api/report_service/hotellinkReport'
import { DEFAULT_GRID_ROW_HEIGHT } from '@/constant'
import SelectWithSearchTable from '@/components/inputs/SelectWithSearchTable.vue'
import { getSourceOTAApi } from '@/api/Statistics/source'
import router from '@/router'

const rowSpan = params => {
  if (params.data.rowSpan) {
    return params.data.rowSpan
  }

  return 1
}
const rowSpan1 = params => {
  if (params.data.rowSpan1) {
    return params.data.rowSpan1
  }

  return 1
}

const cellStyle = params => {
  if (params.data.rowSpan)
    return {
      height: `${DEFAULT_GRID_ROW_HEIGHT * params.data.rowSpan}px`,
      'border-left': '0.5px solid #ccc',
      'border-right': '0.5px solid #ccc',
      'border-bottom': '0.5px solid #ccc',
      top: 0,
      background: '#fff'
    }
}
const cellStyle1 = params => {
  if (params.data.rowSpan1)
    return {
      height: `${DEFAULT_GRID_ROW_HEIGHT * params.data.rowSpan1}px`,
      'border-left': '1px solid #ccc',
      // 'border-right': '1px solid #ccc',
      'border-bottom': '0.5px solid #ccc',
      top: 0,
      background: '#fff'
    }
}
const cellStyle2 = () => {
  return {
    'border-left': '1px solid #ccc',
    // 'border-right': '1px solid #ccc',
    'border-bottom': '0.5px solid #ccc',
    top: 0,
    background: '#fff'
  }
}

export default {
  components: {
    CalendarRange,
    InfoBtn,
    SelectWithSearchTable
  },
  data() {
    return {
      totalAmount: 0,
      totalRoom: 0,
      totalTraveller: 0,
      disabledDate: false,
      loading: false,
      defaultColDef: {
        flex: 1,
        // resizable: true,
        // sortable: true,
        // wrapText: true,
        // autoHeight: true,
        suppressMovable: true,
        headerComponentParams: {
          template:
            '<div class="ag-cell-label-container" role="presentation">' +
            '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
            '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
            // '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>' +
            // '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>' +
            // '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>' +
            // '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>' +
            '    <span ref="eText" class="ag-header-cell-text" role="columnheader" style="white-space: normal;"></span>' +
            // '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
            '  </div>' +
            '</div>'
        }
      },

      defaultDatetimeRange: {
        start: this.$moment().format('YYYY-MM-DD'),
        end: this.$moment().add(7, 'days').format('YYYY-MM-DD')
      },
      datetimeRange: {
        start: this.$moment().format('YYYY-MM-DD'),
        end: this.$moment().add(7, 'days').format('YYYY-MM-DD')
      },
      dialogFormVisible: false,
      dateRangeType: [
        { id: 1, name: 'Ngày tạo booking' },
        { id: 2, name: 'Ngày Checkin' },
        { id: 3, name: 'Ngày Checkout' }
      ],
      searchParams: {
        dateType: 1,
        bookingId: null,
        name: null,
        dateFrom: this.$moment().format('YYYY-MM-DD'),
        dateTo: this.$moment().format('YYYY-MM-DD'),
        sourceId: null
      },
      defaultSearchParams: {
        dateType: 1,
        bookingId: null,
        name: null,
        dateFrom: this.$moment().format('YYYY-MM-DD'),
        dateTo: this.$moment().format('YYYY-MM-DD'),
        sourceId: null
      },
      sourceOptions: [],

      columnsSource: [
        {
          headerName: 'Mã nguồn',
          field: 'code',
          minWidth: 120,
          maxWidth: 150
        },
        {
          headerName: 'Tên nguồn',
          field: 'name',
          // tooltipFiled: 'desc',
          flex: 1
        }
      ],

      columns: [
        {
          headerName: '#',
          field: 'index',
          minWidth: 50,
          resizable: false,
          rowSpan: rowSpan,
          cellStyle: cellStyle
          // cellStyle: {'padding-left': '12px'}
          // valueGetter: params => params.node.rowIndex + 1
        },
        {
          headerName: this.$t('grid.column.pmsCode'),
          field: 'pms_recode',
          // cellClass: "grid-cell-centered",
          sortable: false,
          minWidth: 120,
          rowSpan: rowSpan,
          cellRenderer: params => {
            if (params.value) {
              return `<a class="cursor-pointer" data-action="view-booking" style="color:blue; text-decoration:underline">${params.value}</a>`
            }
          },
          onCellClicked: params => {
            const isClicked =
              params.event?.target?.getAttribute('data-action') ===
              'view-booking'
            if (isClicked && params.value) {
              // Call the method
              this.onViewBooking(params.value)
            }
          },
          tooltipField: 'code',
          // cellClass: "grid-cell-centered",
          cellStyle: cellStyle
        },
        {
          headerName: this.$t('grid.column.cmCode'),
          field: 'cm_recode',
          // cellClass: "grid-cell-centered",
          sortable: false,
          minWidth: 180,
          rowSpan: rowSpan,
          cellRenderer: params => {
            if (params.value) {
              return `<span>${params.value}</span>`
            }
          },
          tooltipField: 'code',
          // cellClass: "grid-cell-centered",
          cellStyle: cellStyle
        },
        {
          headerName: this.$t('grid.column.hotelLinkStatus'),
          field: 'status',
          tooltipField: 'status',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 120,
          rowSpan: rowSpan,
          cellRenderer: params => {
            if (params.value) {
              return `<span>${params.value}</span>`
            }
          },
          // cellClass: "grid-cell-centered",
          cellStyle: cellStyle
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.hotelLinkChannel'),
          field: 'channel',
          tooltipField: 'channel',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 120,
          rowSpan: rowSpan,
          cellRenderer: params => {
            if (params.value) {
              return `<span>${params.value}</span>`
            }
          },
          // cellClass: "grid-cell-centered",
          cellStyle: cellStyle
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.hotelLinkBookingDate'),
          field: 'booking_date',
          tooltipField: 'booking_date',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 110,
          rowSpan: rowSpan,
          cellRenderer: params => {
            if (params.value) {
              return `<span>${this.$moment(params.value).format(
                'HH:MM DD-MM-YYYY'
              )}</span>`
            }
          },
          // cellClass: "grid-cell-centered",
          cellStyle: cellStyle
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.hotelLinkCheckin'),
          field: 'checkin',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 120,
          rowSpan: rowSpan,
          cellRenderer: params => {
            if (params.value) {
              return `<span>${this.$moment(params.value).format(
                'DD-MM-YYYY'
              )}</span>`
            }
          },
          // cellClass: "grid-cell-centered",
          cellStyle: cellStyle,
          tooltipField: 'checkin'

          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.hotelLinkCheckout'),
          field: 'checkout',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 120,
          rowSpan: rowSpan,
          cellRenderer: params => {
            if (params.value) {
              return `<span>${this.$moment(params.value).format(
                'DD-MM-YYYY'
              )}</span>`
            }
          },
          // cellClass: "grid-cell-centered",
          cellStyle: cellStyle,
          tooltipField: 'checkout'

          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.hotelLinkName'),
          field: 'traveller_name',
          tooltipField: 'traveller_name',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 150,
          rowSpan: rowSpan,
          cellRenderer: params => {
            if (params.value) {
              return `<span>${params.value}</span>`
            }
          },
          // cellClass: "grid-cell-centered",
          cellStyle: cellStyle
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.hotelLinkPhone'),
          field: 'phone_number',
          tooltipField: 'phone_number',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 150,
          rowSpan: rowSpan,
          cellRenderer: params => {
            if (params.value) {
              return `<span>${params.value}</span>`
            }
          },
          // cellClass: "grid-cell-centered",
          cellStyle: cellStyle
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.hotelLinkRoomNum'),
          field: 'room_number',
          tooltipField: 'room_number',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 120,
          rowSpan: rowSpan,
          cellRenderer: params => {
            if (params.value) {
              return `<span>${params.value}</span>`
            }
          },
          // cellClass: "grid-cell-centered",
          cellStyle: cellStyle
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.hotelLinkGuestNum'),
          field: 'traveller_number',
          tooltipField: 'traveller_number',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 120,
          rowSpan: rowSpan,
          cellRenderer: params => {
            if (params.value) {
              return `<span>${params.value}</span>`
            }
          },
          // cellClass: "grid-cell-centered",
          cellStyle: cellStyle
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.hotelLinkTotalAmount'),
          field: 'amount',
          rowSpan: rowSpan,
          cellRenderer: params => {
            if (params.value !== null && params.value !== undefined) {
              return `<span>${Number(params.value).toLocaleString('en')}</span>`
            }
          },
          tooltipValueGetter: params => {
            return this.$displayCurrency(params.data.amount)
          },
          // cellClass: "grid-cell-centered",
          cellStyle: cellStyle,
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 110,
          maxWidth: 110
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.hotelLinkPaymentNote'),
          field: 'payment_note',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 300,
          maxWidth: 300,
          rowSpan: rowSpan1,
          cellRenderer: params => {
            if (params.value) {
              return `<span>${params.value}</span>`
            }
          },
          // cellClass: "grid-cell-centered",
          cellStyle: cellStyle1
          // cellClass: "grid-cell-centered",
        },

        {
          headerName: this.$t('grid.column.hotelLinkBookingNote'),
          field: 'booking_note',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 300,
          maxWidth: 300,
          rowSpan: rowSpan1,
          cellRenderer: params => {
            if (params.value) {
              return `<span>${params.value}</span>`
            }
          },
          // cellClass: "grid-cell-centered",
          cellStyle: cellStyle1
          // cellClass: "grid-cell-centered",
        }
      ],
      rows: []
    }
  },
  computed: {
    recode() {
      return this.searchParams.bookingId
    },
    formatNumberField() {
      return ['amount']
    }
  },
  watch: {
    recode: {
      handler(val) {
        if (val) {
          this.disabledDate = true

          this.datetimeRange = {
            start: null,
            end: null
          }
          this.searchParams.dateFrom = null
          this.searchParams.dateTo = null
          this.searchParams.dateType = null
          this.searchParams.name = null
          this.searchParams.sourceId = null
        } else {
          this.disabledDate = false
          this.datetimeRange = {
            start: this.$moment().format('YYYY-MM-DD'),
            end: this.$moment().add(7, 'days').format('YYYY-MM-DD')
          }
          this.searchParams.dateFrom = this.$moment().format('YYYY-MM-DD')
          this.searchParams.dateTo = this.$moment().format('YYYY-MM-DD')
          this.searchParams.dateType = 1
        }
      },
      deep: true
    }
  },
  created() {
    this.getListSource()
  },
  mounted() {
    this.attachData()
  },
  methods: {
    getCellValue(row, column) {
      // Giống valueGetter
      if (column.valueGetter) {
        return column.valueGetter(row)
      }
      if (this.formatNumberField.includes(column.field)) {
        return this.$displayCurrency(row[column.field])
      }
      return row[column.field]
    },
    onViewBooking(pms_recode) {
      const routeData = this.$router.resolve({
        path: '/reservation/new_reservation',
        query: {
          action: 'edit',
          id: pms_recode
        }
      })
      window.open(routeData.href, '_blank')
    },
    displayNumber(row, column, cellValue) {
      console.log('rowwww2,', row, cellValue)
      return this.$displayCurrency(cellValue)
    },
    objectSpanMethod(data) {
      // 0 1 2 (3, 4) 5  (10) 11 12 13 14
      if (
        data.columnIndex <= 2 ||
        data.columnIndex === 5 ||
        data.columnIndex >= 11
      ) {
        if (data.row.rowSpan !== undefined)
          return {
            rowspan: data.row.rowSpan,
            colspan: 1
          }
        else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      } else if (
        data.columnIndex == 3 ||
        data.columnIndex == 4 ||
        data.columnIndex == 10
      ) {
        if (data.row.rowSpan1 !== undefined)
          return {
            rowspan: data.row.rowSpan1,
            colspan: 1
          }
        else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    },
    headerHeightGetter() {
      var columnHeaderTexts = [
        ...document.querySelectorAll('.ag-header-cell-text')
      ]
      var clientHeights = columnHeaderTexts.map(
        headerText => headerText.clientHeight
      )
      var tallestHeaderTextHeight = Math.max(...clientHeights)

      return tallestHeaderTextHeight
    },
    headerHeightSetter() {
      var padding = 40
      var height = this.headerHeightGetter() / 2 + padding
      this.$refs.agGrid.gridApi.setHeaderHeight(height)
      this.$refs.agGrid.gridApi.resetRowHeights()
    },
    handleCommand(cmmd) {
      if (cmmd == 'excel') {
        getListHotelinkReportExcel(this.searchParams).then(res => {
          if (res) {
            const date = this.$moment().format('DD-MM-YYYY')
            const href = URL.createObjectURL(res)
            // create "a" HTML element with href to file & click
            const link = document.createElement('a')
            link.href = href
            link.setAttribute(
              'download',
              'reservation_report_' + date + '.xlsx'
              // res.headers['content-disposition'].split('filename=')[1],
            ) // or any other extension
            document.body.appendChild(link)
            link.click()
            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link)
            URL.revokeObjectURL(href)
          } else {
            throw new Error(res)
          }
        })
      }
    },
    async getListSource() {
      const data = await getSourceOTAApi({ isActive: 1 })

      this.sourceOptions = data.data
      this.sourceOptions.push({
        id: null,
        name: '',
        code: 'Tất cả'
      })

      this.sourceOptions = this.sourceOptions.sort((a, b) => {
        return a.code === 'Tất cả' ? -1 : b.code === 'Tất cả' ? 1 : 0
      })
    },
    merge(arr1, arr2) {
      return [...new Set([...arr1, ...arr2])]
    },
    onSelectRowSource(val) {
      this.searchParams.sourceId = val?.id
    },
    async attachData() {
      try {
        this.loading = true
        let data = await getListHotelinkReport(
          Object.fromEntries(
            Object.entries(this.searchParams).filter(
              ([_, value]) => value !== null
            )
          )
        )
        this.loading = false
        this.rows = data.data?.list
        this.totalAmount = data.data?.totalAmount
        this.totalRoom = data.data?.totalRoom
        this.totalTraveller = data.data?.totalTraveller
        // this.rows = data.data
      } catch {
      } finally {
        this.loading = false
      }
    },
    setDateRange(range) {
      this.searchParams.dateFrom = range.start
      this.searchParams.dateTo = range.end
    },
    onReset() {
      this.searchParams = { ...this.defaultSearchParams }
      this.datetimeRange = { ...this.defaultDatetimeRange }
      this.attachData()
    }
  }
}
</script>

<style lang="scss">
.grid-scroll {
  .ag-cell-focus,
  .ag-cell-no-focus {
    border: 0.5px !important;
  }
  /* This CSS is to not apply the border for the column having 'no-border' class */
  .no-border.ag-cell:focus {
    border: 0.5px !important;
    outline: none;
  }
}
</style>
